// extracted by mini-css-extract-plugin
export default {"StarRating":"StarRating_StarRating__3vrls","SizeS":"StarRating_SizeS__5+y93","SizeM":"StarRating_SizeM__R1yB8"};